// Currency, dates — Austria style (€, DD.MM.YYYY).
export function money(v) {
  const n = Number(v || 0);
  return `€${n.toFixed(2).replace(".", ",")}`;
}

export function shortMoney(v) {
  const n = Number(v || 0);
  return `€${n.toFixed(0)}`;
}

export function formatDateAT(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}.${d.getFullYear()}`;
}

export function formatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toLocaleTimeString("de-AT", { hour: "2-digit", minute: "2-digit" });
}

export function minutesSince(iso) {
  if (!iso) return 0;
  const d = new Date(iso);
  return Math.max(0, Math.floor((Date.now() - d.getTime()) / 60000));
}
